import dayjs from 'dayjs'

type UseSessionsDateProps = {
  utcStartAt: string
  utcEndAt: string
}

const useSessionsDate = ({ utcStartAt, utcEndAt }: UseSessionsDateProps) => {
  const startDate = dayjs(new Date(utcStartAt))
  const endDate = dayjs(new Date(utcEndAt))

  const dateSession = startDate.format('YYYY/MM/DD')
  const dateSessionFormat = startDate.format('DD/MM/YYYY')
  const dateEndSession = endDate.format('YYYY/MM/DD')
  const today = dayjs().format('YYYY/MM/DD')
  const hourInitSession = startDate.format('HH:mm')
  const hourEndSession = endDate.format('HH:mm')
  const hourNow = dayjs().format('HH:mm')

  const daysToNextSession = dayjs(dateSession).diff(today, 'days')
  const hoursToNextSession = startDate.diff(new Date(), 'hours')
  const minutesToNextSession = startDate.diff(new Date(), 'minutes')

  const isSessionFinished = dayjs(dateEndSession).diff(today, 'days') < 0
  const isSessionInProgress = minutesToNextSession < 1 && hourNow <= hourEndSession

  const durationSeconds = startDate.diff(new Date(), 'second')

  const isAllowAccess =
    daysToNextSession <= 0 &&
    !isSessionFinished &&
    hoursToNextSession < 1 &&
    hourNow <= hourEndSession

  return {
    isAllowAccess,
    isSessionInProgress,
    dateSession,
    dateSessionFormat,
    hourInitSession,
    hourEndSession,
    durationSeconds,
    daysToNextSession
  }
}

export default useSessionsDate
